import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PrimaryCardWithCollection from 'Components/ComponentLibrary/Molecules/PrimaryCardWithCollection';
import { useSummarySidebarContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import SidebarSubtitle from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/SidebarSubtitle';
import fr from 'facet-rest';

const styles = () => ({
  root: {},
});

const SidebarIncomeSection = ({
  className,
  classes,
  showTitle,
}) => {
  const {
    incomeData,
    handleAddIncome,
    handleModifyIncome,
  } = useSummarySidebarContentContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {showTitle && <SidebarSubtitle title={'Income'} />}
      {incomeData?.map(incomeSection => {
        return (
          <PrimaryCardWithCollection
            key={incomeSection.id()}
            resource={incomeSection}
            onAdd={incomeSection.relationship(fr.relationships.addIncome.name) ? () => handleAddIncome(incomeSection) : null}
            onEdit={(incomeResource) => handleModifyIncome(incomeResource)}
            title={incomeSection.attr('clientName')}
            itemCollection={incomeSection.attr('incomes')}
            getItemPrimaryText={(incomeItem) => {
              return `${incomeItem.attr('annualGrossValue')} ${incomeItem.attr('description')}`;
            }}
            getItemSecondaryText={(incomeItem) => {
              return `${incomeItem.attr('startDate')} - ${incomeItem.attr('endDate')}`;
            }}
            emptyListAlertTitle={'No Income'}
          />
        );
      })}
    </Box>
  );
};

SidebarIncomeSection.defaultProps = {
  className: '',
  showTitle: true,
};

SidebarIncomeSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
};

export default withStyles(styles)(SidebarIncomeSection);
